var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.name)+":\n  "),_c('br'),_vm._v(" "),_c('input',{staticClass:"dimension",attrs:{"name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.inputHandler}})])}
var staticRenderFns = []

export { render, staticRenderFns }